import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {message} from "antd";
import {
  generateErrorMessage,
  sendGetRequest,
} from "../../services/requestAdaptor";

const initialState = {
  loading: false,
  category: [],
  mainCategory: [],
  product: [],
  supplier: [],
  shipping: [],
  customer: [],
  rack: [],
  block: [],
  level: [],
  bin: [],
  sub_bin: [],
  location: [],
};

export const fetchAllCategory = createAsyncThunk(
  "masterData/fetchAllCategory",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/sub-category?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchAllMainCategory = createAsyncThunk(
  "masterData/fetchAllMainCategory",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/category?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchAllProducts = createAsyncThunk(
  "masterData/fetchAllProducts",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/product?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchAllSuppliers = createAsyncThunk(
  "masterData/fetchAllSuppliers",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/supplier?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchAllCustomers = createAsyncThunk(
  "masterData/fetchAllCustomers",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/customer?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchAllShipping = createAsyncThunk(
  "masterData/fetchAllShipping",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/shipping?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchAllRack = createAsyncThunk(
  "masterData/fetchAllRack",
  async (_, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest("/api/rack");
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchBlock = createAsyncThunk(
  "masterData/fetchBlock",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/block?rack_id=${val}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchLevel = createAsyncThunk(
  "masterData/fetchLevel",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/level?block_id=${val}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchBin = createAsyncThunk(
  "masterData/fetchBin",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/bin?level_id=${val}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchSubBin = createAsyncThunk(
  "masterData/fetchSubBin",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/sub-bin?bin_id=${val}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const fetchLocation = createAsyncThunk(
  "masterData/fetchLocation",
  async (val, {rejectWithValue}) => {
    try {
      const {data} = await sendGetRequest(`/api/location?${val || ""}`);
      return data.data;
    } catch (error) {
      message.error(generateErrorMessage(error));
      return rejectWithValue(error);
    }
  }
);

export const masterDataSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Category Reducer
      .addCase(fetchAllCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload;
      })
      .addCase(fetchAllCategory.rejected, (state) => {
        state.loading = false;
      })

      // Main Category Reducer
      .addCase(fetchAllMainCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllMainCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.mainCategory = action.payload;
      })
      .addCase(fetchAllMainCategory.rejected, (state) => {
        state.loading = false;
      })

      // Product Reducer
      .addCase(fetchAllProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload;
      })
      .addCase(fetchAllProducts.rejected, (state) => {
        state.loading = false;
      })

      // Supplier Reducer
      .addCase(fetchAllSuppliers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.supplier = action.payload;
      })
      .addCase(fetchAllSuppliers.rejected, (state) => {
        state.loading = false;
      })

      // Customer Reducer
      .addCase(fetchAllCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customer = action.payload;
      })
      .addCase(fetchAllCustomers.rejected, (state) => {
        state.loading = false;
      })

      // Shipping Reducer
      .addCase(fetchAllShipping.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllShipping.fulfilled, (state, action) => {
        state.loading = false;
        state.shipping = action.payload;
      })
      .addCase(fetchAllShipping.rejected, (state) => {
        state.loading = false;
      })

      // Rack Reducer
      .addCase(fetchAllRack.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllRack.fulfilled, (state, action) => {
        state.loading = false;
        state.rack = action.payload;
      })
      .addCase(fetchAllRack.rejected, (state) => {
        state.loading = false;
      })

      // Block Reducer
      .addCase(fetchBlock.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBlock.fulfilled, (state, action) => {
        state.loading = false;
        state.block = action.payload;
      })
      .addCase(fetchBlock.rejected, (state) => {
        state.loading = false;
      })

      // Level Reducer
      .addCase(fetchLevel.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLevel.fulfilled, (state, action) => {
        state.loading = false;
        state.level = action.payload;
      })
      .addCase(fetchLevel.rejected, (state) => {
        state.loading = false;
      })

      // Bin Reducer
      .addCase(fetchBin.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBin.fulfilled, (state, action) => {
        state.loading = false;
        state.bin = action.payload;
      })
      .addCase(fetchBin.rejected, (state) => {
        state.loading = false;
      })

      // Sub Bin Reducer
      .addCase(fetchSubBin.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubBin.fulfilled, (state, action) => {
        state.loading = false;
        state.sub_bin = action.payload;
      })
      .addCase(fetchSubBin.rejected, (state) => {
        state.loading = false;
      })

      // Location Reducer
      .addCase(fetchLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.location = action.payload;
      })
      .addCase(fetchLocation.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {setLoading} = masterDataSlice.actions;

export default masterDataSlice.reducer;
